import { t } from '@lingui/macro';

import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';

import { sendP2PSocketData } from './p2pConnection';

let peerFindTimer = null;

export const peerFoundHandler = (dataRec, clearTimer: boolean = false) => {
    if (clearTimer && peerFindTimer) {
        return clearTimeout(peerFindTimer);
    }
    if (dataRec && dataRec !== '') {
        store.dispatch(p2pActions.updatePeerFound('Found Peer'));
        if (peerFindTimer) {
            clearTimeout(peerFindTimer);
        }
        sendP2PSocketData({
            command: 'connect_peer',
            data: dataRec,
        });
    } else {
        store.dispatch(
            p2pActions.updatePeerFound('No available peer Found at the moment'),
        );
        if (peerFindTimer) {
            clearTimeout(peerFindTimer);
        }

        peerFindTimer = setTimeout(() => {
            store.dispatch(p2pActions.updatePeerFound(t`trying again`));
            sendP2PSocketData({
                command: 'getpeer',
                data: [],
            });
        }, 6000);
    }
};
